import type { ReactNode, MouseEventHandler } from 'react';
import { Button as MantineButton } from '@mantine/core';
import type { ButtonProps as MantineButtonProps } from '@mantine/core';
import './Button.css';

export interface ButtonProps extends Omit<MantineButtonProps, 'variant'> {
  variant?: 'primary' | 'secondary' | 'round' | 'icon' | 'secondary-icon';
  loading?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
  fullWidth?: boolean;
  leftAddon?: ReactNode;
  rightAddon?: ReactNode;
}

export default function Button({
  variant = 'primary',
  className = '',
  children,
  loading,
  leftAddon,
  rightAddon,
  size,
  loaderProps,
  ...props
}: ButtonProps) {
  const buttonClass = `button button--${variant} ${className}`.trim();

  return (
    <MantineButton
      className={buttonClass}
      loading={loading}
      loaderProps={{ color: 'currentColor', ...loaderProps }}
      leftSection={leftAddon}
      rightSection={rightAddon}
      size={size}
      {...props}
    >
      {children}
    </MantineButton>
  );
}

